import { Heading } from "@hawkins/components";

import { M1Button } from "../../molecules/M1Button/M1Button.tsx";

import styles from "./ErrorSubmittingForm.module.scss";

export const ErrorSubmittingForm = () => {
  return (
    <div className={styles.errorSubmittingForm}>
      <Heading level={3}>Error Submitting Form. Please try again.</Heading>
      <M1Button
        variant="primary"
        onClick={() => {
          window.location.reload();
        }}
      >
        Try Again
      </M1Button>
    </div>
  );
};
